// ================================
// SIDEBAR CONTEXT (provide/inject)
// ================================
// État partagé entre LayoutWithSidebar et les composants sidebar (collapse, toggle).

import type { InjectionKey, Ref } from "vue"

export interface SidebarContextValue {
    collapsed: Ref<boolean>
    toggle: () => void
    /** Referme la sidebar (ex. après navigation sur mobile). */
    collapse: () => void
}

export const SIDEBAR_CONTEXT_KEY: InjectionKey<SidebarContextValue> =
    Symbol("sidebar-context")
